module.exports = __webpack_public_path__ + "static/img/5.59b1cad.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/2/zh/5.png
// module id = ydms
// module chunks = 0